import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useScarcity } from '../hooks/useScarcity';
import { Button } from './ui/Button';
import { EyeIcon } from 'lucide-react';
export function Header() {
  const copies = useScarcity();
  const [viewers, setViewers] = useState(0);
  useEffect(() => {
    // Initialize with a random number
    setViewers(Math.floor(Math.random() * (284 - 127 + 1)) + 127);
    // Fluctuate every 3-8 seconds
    const interval = setInterval(() => {
      setViewers(prev => {
        const change = Math.floor(Math.random() * 7) - 2; // -2 to +4
        return Math.max(80, Math.min(350, prev + change));
      });
    }, Math.floor(Math.random() * 5000) + 3000);
    return () => clearInterval(interval);
  }, []);
  return <header className="fixed top-0 left-0 right-0 z-50 bg-[#FDF8F0]/90 backdrop-blur-md border-b border-[#C8956C]/20 shadow-sm" data-id="element-12">
      {/* Scarcity Bar */}
      <div className="bg-[#D4654A] text-white text-xs md:text-sm py-2 px-4 flex items-center justify-center gap-2 font-bold" data-id="element-13">
        <motion.div animate={{
        opacity: [1, 0.5, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} className="w-2 h-2 rounded-full bg-white" data-id="element-14" />
        <span data-id="element-15">
          ¡ATENCIÓN! Solo quedan {copies} copias disponibles con descuento
        </span>
      </div>

      {/* Main Header */}
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between" data-id="element-16">
        <div className="font-heading font-bold text-xl md:text-2xl text-[#3D2B1F]" data-id="element-17">
          Drenaje<span className="text-[#C8956C]" data-id="element-18">Brasileño</span>
        </div>
        <Button className="!py-2 !px-4 md:!px-6 !text-xs md:!text-sm !rounded-full" data-id="element-19">
          ¡QUIERO MI GUÍA!
        </Button>
      </div>

      {/* Live Viewers Bar */}
      <div className="bg-[#FAF3E8] border-t border-[#C8956C]/10 py-1.5 px-4 flex items-center justify-center gap-2" data-id="element-20">
        <motion.div animate={{
        scale: [1, 1.3, 1],
        opacity: [1, 0.7, 1]
      }} transition={{
        duration: 1.5,
        repeat: Infinity
      }} className="w-2 h-2 rounded-full bg-red-500" data-id="element-21" />
        <div className="flex items-center gap-1.5 text-xs text-[#5A4332] font-medium" data-id="element-22">
          <EyeIcon className="w-3.5 h-3.5 text-[#C8956C]" data-id="element-23" />
          <span data-id="element-24">
            <strong className="text-[#3D2B1F]" data-id="element-25">{viewers}</strong> personas
            viendo esta página ahora
          </span>
        </div>
      </div>
    </header>;
}